import { SessionContext } from '@session'
import { useContext } from 'react'

export function useSession() {
  return useContext(SessionContext)
}
